import { MMDReads } from '../../models/mmd-read';
import {
  MMD_LOAD_REQUESTED,
  MMD_LOAD_SUCCESS,
  MMD_LOAD_FAILURE,
  MMD_SEEN
} from './actions';
import { RESET_DATA } from '../actions';
import { PayloadAction } from '@ipreo/muni-shared';

// tslint:disable:no-null-keyword
export interface MMDState {
  mmdReads: MMDReads;
  loading: boolean;
  unseen: boolean;
  error?: string;
}

export const mmdDefaultState: MMDState = {
  mmdReads: {
    reads: []
  },
  loading: false,
  unseen: true
};

export function mmdReadsReducer(
  state = mmdDefaultState,
  action: PayloadAction<MMDReads | string>
): MMDState {
  switch (action.type) {
    case MMD_LOAD_REQUESTED:
      return {
        ...state,
        loading: true
      };
    case MMD_LOAD_SUCCESS:
      return {
        mmdReads: (action as PayloadAction<MMDReads>).payload,
        loading: false,
        unseen:
          state.unseen ||
          determineUnseen(
            state.mmdReads,
            (action as PayloadAction<MMDReads>).payload
          )
      };
    case MMD_LOAD_FAILURE:
      return {
        ...mmdDefaultState,
        error: (action as PayloadAction<string>).payload,
        loading: false
      };
    case MMD_SEEN:
      return {
        ...state,
        unseen: false
      };
    case RESET_DATA:
      return mmdDefaultState;
    default:
      return state;
  }
}

function determineUnseen(previousState: MMDReads, newState: MMDReads): boolean {
  if (!previousState) {
    return !!newState.reads.length;
  } else {
    return previousState.timeOfDay !== newState.timeOfDay;
  }
}

export const getMMDReads = (state: MMDState) => state.mmdReads;
export const getMMDLoading = (state: MMDState) => state.loading;
export const getMMDUnseen = (state: MMDState) => state.unseen;
